var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/dashboard"}},[_vm._v("Back to dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }